import { User } from '@elio/emanager-front/auth/model';
import { createAction, props } from '@ngrx/store';

const loginSuccess = createAction(
  '[Login form Store] Login SUCCESS',
  props<{ user: User; jwtAccessToken: string; rememberMe: boolean }>()
);

export const LoginFormActions = {
  loginSuccess,
};
